import LinearScaleIcon from '@mui/icons-material/LinearScale'
import SaveIcon from '@mui/icons-material/Save'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useState } from 'react'
import {
  Button,
  Edit,
  FormTab,
  ListButton,
  TabbedForm,
  TopToolbar,
  useRecordContext,
  useSidebarState,
} from 'react-admin'
import { Link, useLocation } from 'react-router-dom'
import { GuidedBoatForm, ToggleNotesButton, UpsertBoat, UpsertBoatAttributes } from '~/components'
import { GUIDED_FORM_ID, guidedFormRoot, isGuidedPath } from '~/helpers'

const BoatName = (props) => {
  const record = useRecordContext(props)

  return <span>Boot: {record ? `${record.name}` : ''}</span>
}

const RemoteSaveButton = ({ saveProps }) => {
  const { invalid, pristine, saving } = saveProps
  return (
    <Button
      type='submit'
      form={GUIDED_FORM_ID}
      variant='text'
      size='small'
      disabled={invalid || pristine || saving}
      label='ra.action.save'
    >
      <SaveIcon />
    </Button>
  )
}

// The record from context: react-admin 5 passes no `data`, and the guided-input
// link went to /boats/undefined/guided.
const BoatEditActions = ({ guided, saveProps, showToggleNotes, showNotes, setShowNotes }) => {
  const data = useRecordContext()
  return (
    <TopToolbar>
      {saveProps && <RemoteSaveButton saveProps={saveProps} />}
      {showToggleNotes && <ToggleNotesButton showNotes={showNotes} setShowNotes={setShowNotes} />}
      {!guided && (
        <Button
          component={Link}
          to={`/boats/${data?.id}/guided`}
          label='resources.boats.guided_input'
        >
          <LinearScaleIcon />
        </Button>
      )}
      <ListButton label='ra.action.back' />
    </TopToolbar>
  )
}

export const BoatEdit = (props) => {
  const { pathname } = useLocation()
  const guided = isGuidedPath(pathname)
  const firstTabMatch = pathname.endsWith('/1')
  const [open, setSidebarOpen] = useSidebarState()
  const [saveProps, setSaveProps] = useState(null)
  const [showNotes, setShowNotes] = useState(false)

  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'))

  return guided ? (
    <Edit
      title={<BoatName />}
      actions={<BoatEditActions guided saveProps={saveProps} />}
      {...props}
      style={isXSmall ? {} : { marginLeft: open ? '244px' : '60px' }}
      mutationMode='pessimistic'
      key='guided_edit'
    >
      <GuidedBoatForm
        formRootPathname={guidedFormRoot(pathname)}
        warnWhenUnsavedChanges
        saveProps={saveProps}
        setSaveProps={setSaveProps}
      />
    </Edit>
  ) : (
    <Edit
      title={<BoatName />}
      actions={
        <BoatEditActions
          showToggleNotes={!!firstTabMatch}
          showNotes={showNotes}
          setShowNotes={setShowNotes}
        />
      }
      {...props}
      mutationMode='undoable'
      redirect='show'
    >
      <TabbedForm warnWhenUnsavedChanges>
        <FormTab label='resources.boats.base'>
          <UpsertBoat {...props} />
        </FormTab>
        <FormTab label='resources.boats.attributes'>
          <UpsertBoatAttributes {...props} showNotes={showNotes} />
        </FormTab>
      </TabbedForm>
    </Edit>
  )
}

export default BoatEdit
